import '../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import oktaUnderscore from '../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
export { default as _ } from '../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';

oktaUnderscore.mixin({
  nestedOmit: function (obj, names) {
    let result = oktaUnderscore.omit(obj, names);
    if (names.includes(result.name)) {
      result = oktaUnderscore.omit(result, 'value');
    }
    oktaUnderscore.each(result, function (val, key) {
      if (Array.isArray(val)) {
        result[key] = val.map(v => {
          return oktaUnderscore.nestedOmit(v, names);
        });
      } else if (typeof val === 'object') {
        result[key] = oktaUnderscore.nestedOmit(val, names);
      }
    });
    return result;
  }
});
//# sourceMappingURL=mixins.js.map
